var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37967",
    "data-name": "Group 37967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37966",
    "data-name": "Group 37966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33365",
    "data-name": "Path 33365",
    d: "M279,280.568a1.642,1.642,0,0,0,1.641,1.641h1.928a1.642,1.642,0,0,0,1.641-1.641v-1.928A1.642,1.642,0,0,0,282.568,277h-1.928A1.642,1.642,0,0,0,279,278.641Zm1.641-1.928h1.928v1.928h-1.929Z",
    transform: "translate(-267.557 -265.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2319",
    "data-name": "Ellipse 2319",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(15.012 7.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2320",
    "data-name": "Ellipse 2320",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(11.443 7.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33366",
    "data-name": "Path 33366",
    d: "M20.18,14.438a.82.82,0,0,0,.82-.82v-8.7a3.285,3.285,0,0,0-3.281-3.281H16.652V.82a.82.82,0,0,0-1.641,0v.82H11.279V.82a.82.82,0,0,0-1.641,0v.82H5.947V.82a.82.82,0,0,0-1.641,0v.82H3.281A3.285,3.285,0,0,0,0,4.922v12.8A3.285,3.285,0,0,0,3.281,21H17.719A3.285,3.285,0,0,0,21,17.719a.82.82,0,0,0-1.641,0,1.642,1.642,0,0,1-1.641,1.641H3.281a1.642,1.642,0,0,1-1.641-1.641V4.922A1.642,1.642,0,0,1,3.281,3.281H4.307V4.1a.82.82,0,0,0,1.641,0v-.82H9.639V4.1a.82.82,0,0,0,1.641,0v-.82h3.732V4.1a.82.82,0,0,0,1.641,0v-.82h1.066a1.642,1.642,0,0,1,1.641,1.641v8.7A.82.82,0,0,0,20.18,14.438Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2321",
    "data-name": "Ellipse 2321",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(4.307 14.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2322",
    "data-name": "Ellipse 2322",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(4.307 7.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2323",
    "data-name": "Ellipse 2323",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(4.307 11.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2324",
    "data-name": "Ellipse 2324",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(7.875 11.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2325",
    "data-name": "Ellipse 2325",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(7.875 7.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2326",
    "data-name": "Ellipse 2326",
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    transform: "translate(7.875 14.93)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarColored);
export default __webpack_public_path__ + "static/media/calendar-colored.8768aa1d7a9f2d957e7aac7fd7603e24.svg";
export { ForwardRef as ReactComponent };